module.exports = __webpack_public_path__ + "img/1.7c1b377b.jpg";